export const EnvType = {
	PEACOCK: 'peacock',
	NETFLIX: 'netflix',
	APPLETV: 'appletv',
	AMAZON: 'amazon',
};

export const DISPLAY_TYPES = {
	THUMBNAIL: "thumbnail",
	POSTER: "poster",
	BILLBOARD: "billboard",
	BILLBOARD_WIDE : "billboard_wide",
	HIGHLIGHT: "highlight",
};

export const ROW_TYPES = {
	COMING_SOON: 'coming_soon',
	LATEST_RELEASES: 'latest_releases',
	BILLBOARD: 'billboards',
	HIGHLIGHTS: 'highlights'
};

export const CONTENT_TYPES = {
	EPISODIC: "episodic",
	MOVIE: "movie",
	PROMO: "promo",
	HERO: "hero",
	BRANDING: "branding",
	HIGHLIGHT: "highlight"
};

export const ROW_LABELS = {
	BILLBOARD: "Billboard"
};

export const PeacockModalCopies = {
	welcome_modal_header: "Welcome to Peacock",
	welcome_modal_message: "Feel free to explore! As a reminder, you are previewing a simulated streaming environment, so not everything you see will be available. Take a look around and click on anything that is interesting to you! We’ll prompt you to watch a specific show in a few minutes.",

	prompt_curated_content_header: 'Did You Notice This Section?',

	home_page_prompt_header: "Please Return To The Home Page",
	home_page_prompt_message: 'Thanks for looking around! To continue with the study, please return to the home page by clicking the Peacock logos on the left at the top and bottom.',

	prompt_watch_page_header: 'Please Watch The Episode',

	final_step_confirmation_header: 'You Are On The Last Step!',
	final_step_confirmation_message: 'Thanks for going through the environment! As the final step, please watch this video to the end - do not click to leave the page. After the video is ended, you will be sent to the exit survey.',

	peacock_logout_modal_header: 'Thanks for Watching',
	peacock_logout_modal_message: 'Thank you for watching the episode. You will now continue to the Exit Survey of the study.',
};

export const AppleModalCopies = {
	watch_page_prompt_header: "Thanks For Exploring",

	return_to_target_content_header: "Please Continue Watching",
	return_to_target_content_message: 'To receive your incentive, please click "Resume Episode" to finish watching the episode.',

	logout_modal_header: 'Thanks for Watching', 
	logout_modal_message: 'Thank you for watching the episode. You will now continue to the Exit Survey of the study.',

	logout_svod_modal_message: 'Thank you for exploring the AppleTV+ environment. You will now continue to the Exit Survey of the study.',
};

export const PlayerType = {
	adPlayer: "AD_PLAYER",
	mainContentPlayer: "MAIN_CONTENT_PLAYER"
};

// hidden question answers and types
// answers
export const FORCED_ENTRY = 'FORCED ENTRY';
export const MANUAL_NAVIGATION = 'MANUAL NAVIGATION';
export const OPT_IN = 'OPT IN';
export const OPT_OUT = 'OPT OUT';

// types
export const APPLETV_PLUS_QUESTION = 'appletvplusquestion';
export const APPLETV_PLUS_ENTRY = 'appletvplusentry';
export const IWATVP_PLUS_NAVIGATION = 'appletvpluspageentry';
export const SVOD_ASSET_NAVIGATION = 'svod-asset-entry';
export const APPLETV_PLUS_ASSET_ENTRY = 'appletvplus-asset-entry';
export const PEACOCK_ADUNIT = "peacock-ad-unit";
export const PEACOCK_ADCHOICE_USER_SELECTION = "peacock-adchoice-user-selection";

export const SVOD_HIDDEN_QUESTION_TYPES = [IWATVP_PLUS_NAVIGATION, SVOD_ASSET_NAVIGATION, APPLETV_PLUS_ASSET_ENTRY, PEACOCK_ADCHOICE_USER_SELECTION];


// WEBPACK FOOTER //
// ./src/components/svod/constants.js